export const en = {
  roles: {
    rep: "Rep",
    manager: "Manager",
    admin: "Admin",
    owner: "Owner",
  },
  triggers: {
    confirmation_needed: "Confirmation Needed",
    open_draft_orders: "Open Draft Orders",
    checkout_recovery: "Checkout Recovery",
  },
  statuses: {
    open: "Open",
    snoozed: "Snoozed",
    completed: "Completed",
    complete: "Completed",
  },
  priorities: {
    high: "High",
    medium: "Medium",
    low: "Low",
  },
  userStatus: {
    active: "Active",
    deactivated: "Inactive",
    pending: "Pending",
    deleted: "Deleted",
  },
  outcomes: {
    confirmed: "Confirmed",
    call_again: "Call Again",
    no_answer: "No Answer",
    wrong_phone: "Wrong Phone",
    do_not_call: "Do Not Call",
    customer_cancelled: "Customer Asked to Cancel",
    needs_edit: "Needs Edit",
    recovered: "Recovered",
    converted: "Converted",
    cancelled: "Cancelled",
    rescheduled: "Rescheduled",
    left_voicemail: "Left Voicemail",
    wrong_number: "Wrong Number",
    duplicate: "Duplicate",
    not_applicable: "N/A",
    other: "Other",
  },
  notifications: {
    header: "Notifications",
    markAllRead: "Mark all read",
    noNotifications: "No notifications",
    notificationSettings: "Notification Settings",
    preferencesHeader: "Notification Preferences",
    saveError: "Failed to save notification preference.",
    prefToggles: {
      taskAssigned: {
        label: "Task Assigned",
        description: "Notify when a task is assigned to you",
      },
      taskUnassigned: {
        label: "Task Unassigned",
        description: "Notify when a task is removed from your queue",
      },
      teamTaskAssigned: {
        label: "Team Task Assigned",
        description: "Notify when a team member is assigned a task",
      },
      snoozeExpired: {
        label: "Snooze Expired",
        description: "Notify when a snoozed activity is ready for follow-up",
      },
    },
  },
} as const;
